document.addEventListener('DOMContentLoaded', function () {
  var msg = document.querySelector('.announcement-bar__message');
  if (!msg) return;

  var original = msg.innerHTML;
  var separator = '<span class="dr-marquee-sep">&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;</span>';

  msg.innerHTML = original + separator + original + separator + original + separator + original + separator;
});